<template>
  <div>
    <v-btn color="primary" @click="openDialog">
      Extender Periodo de Inscripción
    </v-btn>

    <v-dialog v-model="dialogVisible" max-width="800">
      <template>
        <v-card>
          <v-toolbar color="primary" dark>Extender periodo de Inscripción</v-toolbar>
          <v-card-text class="mt-10">
            <v-tabs vertical v-model="activeTab">
              <v-tab>
                <v-icon left> mdi-account </v-icon>
                Option 1
              </v-tab>
              <!--<v-tab>
                <v-icon left> mdi-lock </v-icon>
                Option 2
              </v-tab>
              <v-tab>
                <v-icon left> mdi-access-point </v-icon>
                Option 3
              </v-tab>-->

              <v-tab-item v-if="activeTab === 0" :key="activeTab">
                <v-card flat>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-select v-model="cantidad" :items="inscripcionesDisponibles"
                            label="Cantidad de Inscripcion a Validar*" required></v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                    <p style="color: #b71c1c">
                      * el monto a cancelar es {{ monto }} $
                    </p>

                    <v-btn id="pagar_mobbex" type="submit" depressed color="primary" @click="validateFormMobbex">
                      Pagar
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item v-if="activeTab === 1" :key="activeTab">
                <v-card flat>
                  <v-card-text>
                    <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                      <v-row>
                        <v-col cols="12" xl="12" lg="12" md="12" sm="12" v-show="inscripcion">
                          <v-alert id="mpLayer" border="left" colored-border color="#125ea5" elevation="2">
                            <h3 class="text-h5">Pago Extencion de Inscripcion</h3>
                            <h4 style="padding-left: 15px; padding-bottom: 20px">
                              Monto: {{ monto }} ARS
                            </h4>
                            <!-- Step #2 -->

                            <v-alert v-show="showErrors" dense outlined type="error"
                              style="margin-left: 15px; margin-right: 15px">
                              <strong>{{ errorMessage }}</strong>
                            </v-alert>

                            <form id="form-checkout">
                              <!-- <input type="hidden" name="IDStB" id="IDStB" :value="this.user.IDStB"> -->

                              <div class="form-group">
                                <label for="cardNumber" class="v-label theme--dark">
                                  Número de la tarjeta
                                </label>
                                <input class="form-control" type="text" required placeholder="XXXXXXXXXXXX"
                                  name="cardNumber" id="form-checkout__cardNumber" />
                                <div v-if="displayError" style="margin-bottom: 18px"></div>
                              </div>

                              <div class="form-group">
                                <label for="cardExpirationDate" class="v-label theme--dark">
                                  Fecha de vencimiento
                                </label>
                                <input class="form-control" type="text" required placeholder="01/2022"
                                  v-model="cardExpirationDate" @input="validateCardExpirationDate"
                                  id="form-checkout__cardExpirationDate" />
                                <div v-if="displayError" style="color: red; font-size: 12px">
                                  Ingrese la fecha con el formato MM/YYYY
                                </div>
                              </div>

                              <div class="form-group">
                                <label for="cardholderName" class="v-label theme--dark">
                                  Titular de la tarjeta
                                </label>
                                <input class="form-control" type="text" required placeholder="John Doe"
                                  name="cardholderName" id="form-checkout__cardholderName" />
                                <div v-if="displayError" style="margin-bottom: 18px"></div>
                              </div>

                              <div class="form-group">
                                <label for="cardholderName" class="v-label theme--dark">
                                  Email
                                </label>
                                <input class="form-control" required type="email" placeholder="john.doe@email.com"
                                  name="cardholderEmail" id="form-checkout__cardholderEmail" />
                              </div>

                              <div class="form-group">
                                <label for="securityCode" class="v-label theme--dark">
                                  Código de seguridad
                                </label>
                                <input class="form-control" type="text" required placeholder="123" name="securityCode"
                                  id="form-checkout__securityCode" />
                              </div>

                              <div class="form-group" style="display: none">
                                <label for="issuer" class="v-label theme--dark">
                                  Emisor de tarjeta
                                </label>
                                <select class="form-control" name="issuer" id="form-checkout__issuer"></select>
                              </div>

                              <div class="form-group">
                                <label for="identificationType" class="v-label theme--dark">
                                  Tipo de identificación
                                </label>
                                <select class="form-control" name="identificationType"
                                  id="form-checkout__identificationType"></select>
                              </div>

                              <div class="form-group">
                                <label for="identificationNumber" class="v-label theme--dark">
                                  Número de identificación
                                </label>
                                <input class="form-control" type="text" required placeholder="12345678"
                                  name="identificationNumber" id="form-checkout__identificationNumber" />
                              </div>

                              <div class="form-group" style="display: none">
                                <label for="installments" class="v-label theme--dark">
                                  Número de cuotas
                                </label>
                                <select class="form-control" name="installments"
                                  id="form-checkout__installments"></select>
                              </div>

                              <div style="width: 100%; text-align: center">
                                <!-- <button type="submit" id="form-checkout__submit">Pagar</button> -->
                                <v-btn id="form-checkout__submit" type="submit" depressed color="primary"
                                  @click="validateForm">
                                  Suscribir
                                </v-btn>
                              </div>

                              <br /><br />
                              <progress class="progress-bar" max="100" value="0" style="display: none"></progress>
                            </form>
                          </v-alert>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item v-if="activeTab === 2" :key="activeTab">
                <v-card flat>
                  <v-card-text>
                    <p v-if="finalizadoSinError">Finalizado sin error</p>

                    <p class="mb-0" v-else>finalizado con error</p>
                  </v-card-text>
                </v-card>
              </v-tab-item>

            </v-tabs>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="dialogVisible = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>
<script src="https://sdk.mercadopago.com/js/v2"></script>
<script>
export default {
  name: "PagoExterno",
  components: {},
  props: {
    inscripcionesDisponibles: {
      type: Array,
      required: false,
    },
    montoXmateria: {
      type: Number,
      required: false,
    },
    idMesa:{
      type:Number,
      required:false
    }
  },
  computed: {
    monto() {
      return this.montoXmateria * this.cantidad;
    },
    user() {
      return this.$store.getters.user;
    }
  },
  updated() {
    this.$nextTick( () => {
      if ( this.dialogVisible && this.activeTab == 1) {
        app.monto = this.monto.toFixed(2);

        // CFPEA
        const mp = new MercadoPago("TEST-6afb0028-e527-47a0-a70e-1df05c7235d1");

        app.cardForm = mp.cardForm({
          amount: "" + this.monto.toFixed(2),
          autoMount: true,

          form: {
            id: "form-checkout",
            cardholderName: {
              id: "form-checkout__cardholderName",
              placeholder: "Titular de la tarjeta",
            },
            cardholderEmail: {
              id: "form-checkout__cardholderEmail",
              placeholder: "Email",
            },
            cardNumber: {
              id: "form-checkout__cardNumber",
              placeholder: "Número de la tarjeta",
            },
            cardExpirationDate: {
              id: "form-checkout__cardExpirationDate",
              placeholder: "MM/YYYY",
            },
            securityCode: {
              id: "form-checkout__securityCode",
              placeholder: "Código de seguridad",
            },
            installments: {
              id: "form-checkout__installments",
              placeholder: "Cuotas",
            },
            identificationType: {
              id: "form-checkout__identificationType",
              placeholder: "Tipo de documento",
            },
            identificationNumber: {
              id: "form-checkout__identificationNumber",
              placeholder: "Número de documento",
            },
            issuer: {
              id: "form-checkout__issuer",
              placeholder: "Banco emisor",
            },
          },

          callbacks: {
            onFormMounted: (error) => {
                console.log(error)
              if (error)
                return console.warn("Form Mounted handling error: ", error);
              console.log("Form mounted");
            },

            onSubmit: (event) => {
              event.preventDefault();

              const {
                paymentMethodId: payment_method_id,
                issuerId: issuer_id,
                cardholderEmail: email,
                amount,
                token,
                installments,
                identificationNumber,
                identificationType,
              } = app.cardForm.getCardFormData();

              let dataSend = {
                token,
                issuer_id,
                email,
                payment_method_id,
                transaction_amount: Number(amount),
                installments: Number(installments),
                description:
                  "IEA suscripción circuito: " + app.$route.params.circuito, // obtener nombre carrera + sede "IEA: Pago ".$sede.' > '.$turno.' > '.$nombrecarreradeinterés
                payer: {
                  identification: {
                    type: identificationType,
                    number: identificationNumber,
                  },
                },
                circuito: app.$route.params.circuito,
                preinscripcion: app.$route.params.preinscripcion,
              };

              let url = "mp-pago-unico";

              this.$API
                .post({
                  url: url,
                  data: dataSend,
                })
                .then((res) => {
                  if (res.status == "success") {
                    console.log(res.mp_response_message);
                    // location.replace(res.go_to_login);
                    //location.replace(res.redirect_to);
                  } else {
                    app.errorMessage = res.mp_response_message;
                    app.showErrors = true;
                  }
                });
            },

            onFetching: (resource) => {
              // Animate progress bar
              const progressBar = document.querySelector(".progress-bar");
              progressBar.removeAttribute("value");

              return () => {
                progressBar.setAttribute("value", "0");
              };
            },
          },
        });
      }
    });
  },
  data: () => ({
    dialogVisible : false,
    cantidad: 0,
    activeTab: 0,
    title: "Registro de Suscripción",
    valid: false,
    cardholderName: "",
    lastname: "",
    cardNumber: "",
    inscripcion: true,
    cardForm: null,
    showErrors: false,
    errorMessage: "",
    // actualizacion : false,
    // informacion : false,
    suscrito: false,
    datosSuscripcion: null,
    nameRules: [
      (v) => !!v || "cardNumber is required",
      (v) => v.length < 12 || "card number must have 12 characters",
    ],
    cardExpirationDate: "",
    displayError: false,
    submitted: false,
    finalizadoSinError: true,
  }),
  methods: {
    validateFormMobbex(){
      let monto=parseFloat(this.monto)
      if(monto<=0){
        alert("el monto a pagar debe ser mayor a 0");
        return false
      }

      let cantidad=this.cantidad
      let id_mesa=this.idMesa

      let dataSend = {
        monto:monto,
        cantidad:cantidad,
        id_mesa:id_mesa,
        alumno : this.user.IDStB
      };

      let url = "mobbex/mobbex-pago-extension-examen";
      this.$API
      .post({
          url: url,
          data: dataSend,
      }).then((res) => {
          location.href = res.data.url
      });

    },
    openDialog() {
      this.dialogVisible = true;
    },
    showAMount() {
      var formatter = new Intl.NumberFormat("es-AR", {
        style: "currency",
        currency: "ARS",
      });

      return formatter.format(
        this.datosSuscripcion.summarized.last_charged_amount
      );
    },
    validateCardExpirationDate() {
      var yearRegex = /^\d{2}\/\d{4}$/;
      this.displayError = !yearRegex.test(this.cardExpirationDate);
    },

    validateForm() {
      this.validateCardExpirationDate();

      //if (this.displayError) {
      event.preventDefault();
      this.submitted = true;
      //}
    },
  },
};
</script>

<style>
#form-checkout {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

#form-checkout .form-group {
  margin-bottom: 1rem;
  width: 33%;
  flex-grow: 1;
  padding-left: 15px;
  padding-right: 15px;
}

#form-checkout .form-group label {
  display: inline-block;
  margin-bottom: 0.5rem;
  color: #000;
}

#form-checkout label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

#form-checkout .form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

#form-checkout__submit {
  width: 200px;
  margin-bottom: 40px;
  margin-left: 15px;
  margin-right: 15px;
}

.text-h5 {
  margin-bottom: 20px;
  margin-left: 15px;
  margin-right: 15px;
}

/* All Progress Bars */
progress {
  /* Reset the default appearance */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  margin-left: 15px;
  margin-right: 15px;
}

/* Determinate */
progress[value] {
  /* Reset the default appearance */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

/* Indeterminate */
progress:not([value]) {
  /* Reset the default appearance */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

progress::-webkit-progress-bar {
  background: #eee;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2) inset;
  border-radius: 3px;
}

progress::-webkit-progress-value {
  background-color: #125ea5;
  border-radius: 3px;
}

progress {
  background: #eee;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2) inset;
  border-radius: 3px;
}

progress::-moz-progress-bar {
  background-color: #125ea5;
  border-radius: 3px;
}

.v-window-item {
  display: flex !important;
}
</style>
